(function webpackUniversalModuleDefinition(root, factory) {
	//Arta System UI
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	//Arta System UI
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	//Arta System UI
	else if(typeof exports === 'object')
		exports["UI"] = factory(require("react"));
	//Arta System UI
	else
		root["UI"] = factory(root["React"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__899__) => {
return 